
import {Component, Prop, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Tutar from "@/components/inputs/Tutar.vue";
import MahkemeSecim from "@/components/inputs/MahkemeSecim.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import KararNumarasi from "@/components/inputs/KararNumarasi.vue";
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import PopUp from "@/components/dialogs/PopUp.vue";
import {PopUpTitle} from "@/enum/PopUpTitle";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";

@Component({
  components: {
    PopUp,
    Kur,
    DovizTakipSekliPicker,
    StepperValidationForm,
    KararNumarasi,
    DosyaEsasNumarasi,
    ProtestoIhtarForm,
    ParaBirimiPicker,
    Tutar,
    Dates,
    MahkemeSecim,
    ItemArrayManager,
    AsilAlacakKalemiForm,
    AyEkleForm,
  },
})
export default class IseIadeAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTalebi !: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  PopUpTitle = PopUpTitle;
  activeStep = 1;
  paraBirimi = ParaBirimi;
  mahkemeAdi: string = "";
  dovizTakipSekli = DovizTakipSekli;
  dialog = false;

  stepperHeaders = [
    "Karar Bilgisi Ekle",
    "İhtar",
    "Alacak Kalemi"
  ];
  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 13,
    dosya: 1
  }

  vadeCheck() {
    this.dialog = true;
  }

  stepCheck() {
    this.dialog = false;
    this.nextStep();
  }

  @Watch('localValue.ihtar_var_mi')
  onIhtarVarMiChange() {
    if (this.localValue.ihtar_var_mi && !this.localValue.ihtarlar) {
      this.localValue.ihtarlar = [];
    } else {
      delete this.localValue.ihtarlar;
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY)
      delete this.localValue.doviz_kur_tarihi;
    this.input();
  }

  mounted() {
    this.$emit('hide-button', true);
    if (!this.localValue.asil_alacaklar) {
      this.localValue.asil_alacaklar = [];
    }
  }
}
